// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthCard_wrapper__HgAMm","forgotPasswordText":"AuthCard_forgotPasswordText__hOyNz"};